import { render, staticRenderFns } from "./Local.vue?vue&type=template&id=78a83c19&scoped=true&"
import script from "./Local.vue?vue&type=script&lang=js&"
export * from "./Local.vue?vue&type=script&lang=js&"
import style0 from "./Local.vue?vue&type=style&index=0&id=78a83c19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a83c19",
  null
  
)

export default component.exports